var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.446,
    height: 14.446,
    viewBox: "0 0 14.446 14.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.613 14.446a.828.828 0 0 1-.589-.244L9.03 10.208l-3.161 3.16A.833.833 0 0 1 4.69 12.19l.31-.312L.525 6.12a2.506 2.506 0 0 1 .206-3.3L2.816.731a2.5 2.5 0 0 1 3.3-.206L11.877 5l.314-.314a.833.833 0 1 1 1.178 1.178L10.208 9.03l3.992 3.994a.833.833 0 0 1-.589 1.423zM4.584 1.665a.826.826 0 0 0-.59.245L1.909 4a.834.834 0 0 0-.069 1.1l4.351 5.59 4.5-4.5L5.1 1.841a.826.826 0 0 0-.516-.176z",
    transform: "translate(0 0) translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelIcon);
export default __webpack_public_path__ + "static/media/Label-icon.72e560c4f5c2404e71e14cc66bcdef2a.svg";
export { ForwardRef as ReactComponent };